export const ShortcutKeys = {
  Delete: ['del', 'backspace', 'delete'],
  Copy: ['ctrl+c', 'command+c'],
  Paste: ['ctrl+v', 'command+v'],
};
